<template>
  <div>
    <section id="hero2">
      <Slick ref="slick" :options="slickOptions" class="slick-item">
        <article style="background:#F1F8F8;">
          <div class="main-wraper">
            <a href="/kr/resume/quickmailhelp">
              <img src="/kr/resume/static/renew_img/bnr/mypage_top_banner_quickmail_20230222.png">
            </a>
          </div>
        </article>

        <article style="background:#F1F8F8;">
          <div class="main-wraper">
            <a href="/kr/resume/quickemailhelp">
              <img src="/kr/resume/static/renew_img/bnr/mypage_top_banner_quickemail_20230410.png">
            </a>
          </div>
        </article>
        <article style="background:#C1EEEE;">
          <div class="main-wraper">
            <a href="#">
              <!-- https://bit.ly/3aGWmcW -->
              <img src="/kr/resume/static/renew_img/bnr/hero1_20220509002.gif">
            </a>
          </div>
        </article>
        <article style="background:#F1F8F8;">
          <div class="main-wraper">
            <a href="https://www.yagish.jp/recruit/" target="_blank">
              <img src="/kr/resume/static/renew_img/bnr/mypage_top_banner_20230403.png">
            </a>
          </div>
        </article>
        <article style="background:#F6DBCA;">
          <div class="main-wraper">
            <a href="https://special.yagish.jp/recommend/index.html" target="_blank">
              <img src="/kr/resume/static/renew_img/bnr/hero6_20221005_001.gif">
            </a>
          </div>
        </article>
        <article style="background:#010043;">
          <div class="main-wraper">
            <a href="http://bit.ly/3OehI0B" target="_blank">
              <img src="/kr/resume/static/renew_img/bnr/hero6_20221118_001.png">
            </a>
          </div>
        </article>
        <!-- 
      <article style="background:#01604F;">
          <div class="main-wraper">
            <a href="https://blog.yagish.jp/entry/2022/09/13/142103?utm_source=blogWidget" target="_blank">
              <img src="/kr/resume/static/renew_img/bnr/hero2_marketing_20220916_001.png">
            </a>
          </div>
      </article>
      <article style="background:#E61616;">
          <div class="main-wraper">
            <a href="https://bit.ly/3aGWmcW" target="_blank" > 
              <img src="/kr/resume/static/renew_img/bnr/top_banner_20220401_001.gif">
            </a>
          </div>
      </article>
      <article style="background:#FFFFFF;">
          <div class="main-wraper">
            <a href="https://blog.yagish.jp/entry/2022/09/14/105320?utm_source=blogWidget" target="_blank">
              <img src="/kr/resume/static/renew_img/bnr/hero2_designer_20220916_001.png">
            </a>
          </div>
      </article> -->
        <!-- <article style="background:#FFC051;" v-if="is_not_midnight">
          <div class="main-wraper">
            <a href="https://bit.ly/3uT6SV6" target="_blank">
              <img src="/kr/resume/static/renew_img/bnr/top_banner_20220305_001.gif">
            </a>
          </div>
      </article> -->
      </Slick>
    </section>
    <section id="navlist">
      <div class="content-wrapper">
        <h2>안녕하세요~메에~~<br>우선 경력기술서부터 선택해줘!</h2>
        <div class="input-middle" v-if="recentEdit.FormatId !== ''">
          <template v-if="recentEdit.FormatId !== ''">
            <p>작성한 내용이<br class="sp">캐쉬데이터로 보존됩니다.</p>
            <div class="btn_wrapper">
              <router-link
                :to="{ name: 'formatEditCard', params: { formatId: recentEdit.FormatId, cardId: recentEdit.cardId } }"
                v-ripple>
                <a class="btn_cta">계속해서 입력</a>
              </router-link>
            </div>
            <div class="btn_wrapper">
              <router-link
                :to="{ name: 'formatPreview', params: { formatId: recentEdit.FormatId, cardId: recentEdit.cardId } }"
                v-ripple>
                <a class="btn_sub">작성내용 검토</a>
              </router-link>
            </div>
          </template>
        </div>
        <article class="flex-box">
          <div class="flex-item" :key="f.id" v-for="f in $site.keirekishoFormatsIndex" :class="recentEditClass(f)"
            style="line-height:1;">
            <p class="tag" v-if="f.id === 'rirekisho_job_change'">추천</p>
            <div class="img_base">
              <img :src="f.thumbnail" :alt="f.title + '템플릿'">
            </div>
            <p class="title">{{ f.title }}</p>
            <ul>
              <li>{{ f.newdetail1 }}</li>
              <li v-if="f.newdetail2 != ''">{{ f.newdetail2 }}</li>
              <li>{{ f.newdetail3 }}</li>
            </ul>
            <router-link :to="{ name: 'formatDetail', params: { formatId: f.id } }"
              v-if="f.id != 'letter' && f.id != 'shokumukeirekisho'">이력서 작성
            </router-link>
            <router-link :to="{ name: 'formatDetail', params: { formatId: f.id } }" style="background-color:orange"
              v-else-if="f.id != 'shokumukeirekisho'">송장 작성
            </router-link>
            <router-link :to="{ name: 'formatDetail', params: { formatId: f.id } }" v-else
              style="background-color:rgb(15, 153, 52)">업무경럭서 작성
            </router-link>
          </div>
        </article>
      </div>
    </section>
    <section id="about">
      <div class="content-wrapper">
        <h2><span>야기슈란?</span></h2>
        <img src="/kr/resume/static/renew_img/about_pc.png" alt="PC, 스마트폰, 태블릿으로 무료로 이력서를 만들 수 있어!" class="pc">
        <img src="/kr/resume/static/renew_img/about_sp.png" alt="PC, 스마트폰, 태블릿으로 무료로 이력서를 만들 수 있어!" class="sp">
        <p>
          yagish(야기슈)는 웹에에서 이력서를 만들 수 있는 무료 서비스입니다.<br>
          이직용, 신규졸업용, 아르바이트용 등 다수의 템플릿을 보유.<br>
          집밖에서도 필요할 때 언제든지 이력서를 작성할 수 있고, 작성한 이력서는 다운로드 할 수 있습니다.
        </p>
      </div>
    </section>
    <section id="howto">
      <div class="content-wrapper">
        <h2><span>야기슈 사용법</span></h2>
        <img src="/kr/resume/static/renew_img/howto_pc.png" alt="3단계로 입력~인쇄까지 웹에서 완성" class="pc step">
        <img src="/kr/resume/static/renew_img/howto_sp.png" alt="3단계로 입력~인쇄까지 웹에서 완성" class="sp step">
        <img src="/kr/resume/static/renew_img/flow_pc.png" class="pc flow" alt="1. 이력서 선택, 2. 이력서 입력 3. pdf 다운로드">
        <img src="/kr/resume/static/renew_img/flow_sp.png" class="sp flow" alt="1. 이력서 선택, 2. 이력서 입력 3. pdf 다운로드">
        <a class="btn_sub" href="/kr/resume/info">상세히 알아보기<img src="/kr/resume/static/renew_img/icon_link.svg"
            alt="야기슈 사용법 상세히"></a>
        <article v-if="!$firebase.isAuthenticated">
          <p class="title">로그인하면<br><span>더욱</span>편리하게 사용 할수 있어요.</p>
          <img src="/kr/resume/static/renew_img/login-merit.png" alt="1. 이력서 백업 2. 편의점 인쇄가 가능하도록">
          <div class="btn_wrapper">
            <a class="btn_cta " href="/kr/resume/login">로그인<img src="/kr/resume/static/renew_img/icon_login.svg"
                alt="로그인"></a>
          </div>
        </article>
      </div>
    </section>
    <blog-widget :json-url="$site.blogJsonUrl" v-if="false"></blog-widget>
  </div>
</template>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
export default {
  components: {
    'blog-widget': blogWidget,
    'yagi-omikuji': YagiOmikuji,
    Slick
  },
  data: function () {
    return {
      is_not_midnight: true,
      recentEdit: {
        FormatId: ''
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 400
      }
    }
  },
  methods: {
    reload: function () {
      location.reload(true)
    },
    recentEditClass: function (format) {
      if (!this.recentEdit) return
      if (this.recentEdit.FormatId === format.id) {
        return {
          'current-edit': true
        }
      }
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    updateRecentEdit: function (data) {
      if (data) {
        this.recentEdit = data
      }
    }
  },
  created: function () {
    // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
    this.loadRecentEdit()
    const now = new Date()
    if (now.getHours() >= 0 && now.getHours() < 6) {
      this.is_not_midnight = false
    }
    this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$on('reload', this.reload)
  },
  destroyed: function () {
    this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$off('reload', this.reload)
  }
}
</script>
